// ─────────────────────────────────────────
//  "Nytt i tRAT" — det lärarna ser i hörnet
// ─────────────────────────────────────────
// Nyast först. id måste vara unikt och får aldrig ändras (det är det som
// sparas som "senast läst"). highlight: true ger en liten ruta i hörnet en
// gång, för större nyheter; annars syns bara pricken på knappen.
// link: valfri sökväg i appen ("Visa" i panelen).
//
// Texterna godkänns av Johan innan de läggs in.

export const RELEASES = [
  {
    id: "2026-11-01-avslutad-stangs",
    date: "2026-11-01",
    highlight: true,
    title: { sv: "Avslutad tRAT stängs för studenterna", en: "An ended tRAT is closed to students" },
    body: {
      sv: "När du avslutar en tRAT skickas grupperna till startsidan och frågorna går inte längre att öppna. Vill du att de ska vara kvar, låt tRATen vara öppen. Grupperna kan också själva välja \"Lämna tRAT:en\" på resultatsidan.",
      en: "When you end a tRAT, the groups are sent to the start page and the questions can no longer be opened. If you want them to stay available, leave the tRAT open. Groups can also choose \"Leave the tRAT\" on the results page themselves.",
    },
  },
  {
    id: "2026-10-19-startsidan",
    date: "2026-10-19",
    highlight: true,
    link: "/",
    title: { sv: "Startsidan visar hela kursens tRATs", en: "The overview shows all your courses' tRATs" },
    body: {
      sv: "Listan visar nu alla tRATs i dina kurser, även kollegornas. Filtrera på kurs eller välj Mina. Överst ser du vad som pågår just nu och hur det gick senast.",
      en: "The list now shows every tRAT in your courses, including your colleagues'. Filter by course or choose Mine. At the top you see what is running and how the last one went.",
    },
  },
  {
    id: "2026-10-19-resultat",
    date: "2026-10-19",
    title: { sv: "Ny resultatsida för grupperna", en: "New results page for the groups" },
    body: {
      sv: "Grupperna ser sin poäng tydligare, med en stapel per försök. Efter avslutad tRAT kan de gå tillbaka och läsa frågorna i lugn och ro.",
      en: "Groups see their score more clearly, with a bar per attempt. After finishing they can go back and read the questions at their own pace.",
    },
  },
  {
    id: "2026-10-13-appeals",
    date: "2026-10-13",
    title: { sv: "Appeals: välj poäng eller avdrag", en: "Appeals: choose points or a deduction" },
    body: {
      sv: "När du godkänner en appeal väljer du den nya poängen, och vid avslag kan du ge avdrag. Kortet visar i vilken ordning gruppen skrapade.",
      en: "When you approve an appeal you choose the new score, and when you reject it you can deduct points. The card shows the order in which the group scratched.",
    },
  },
  {
    id: "2026-10-09-import",
    date: "2026-10-09",
    link: "/create",
    title: { sv: "Importera dina egna frågedokument", en: "Import your own question documents" },
    body: {
      sv: "Ladda upp frågor från Word, PDF eller Excel, eller klistra in text. Mallar finns att ladda ner, och du markerar rätt svar i förhandsvisningen.",
      en: "Upload questions from Word, PDF or Excel, or paste text. Templates are available, and you mark the correct answer in the preview.",
    },
  },
];

// Nyheter som kommit efter den användaren senast läste.
export function unreadReleases(releases, lastSeenId) {
  if (!lastSeenId) return releases;
  const idx = releases.findIndex(r => r.id === lastSeenId);
  return idx === -1 ? releases : releases.slice(0, idx);
}
